var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1157_2452)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8,
    width: 60,
    height: 60,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8.5,
    width: 59,
    height: 59,
    rx: 14.5,
    stroke: "#FF6E4A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 46.8856C38.2111 46.8818 37.9351 46.7654 37.7308 46.5611C37.5265 46.3567 37.41 46.0807 37.4062 45.7918V35.5835C37.4062 35.2934 37.5215 35.0152 37.7266 34.8101C37.9317 34.605 38.2099 34.4897 38.5 34.4897C38.7901 34.4897 39.0683 34.605 39.2734 34.8101C39.4785 35.0152 39.5938 35.2934 39.5938 35.5835V45.7918C39.59 46.0807 39.4735 46.3567 39.2692 46.5611C39.0649 46.7654 38.7889 46.8818 38.5 46.8856ZM38.5 33.0314C38.2111 33.0276 37.9351 32.9112 37.7308 32.7069C37.5265 32.5026 37.41 32.2266 37.4062 31.9377V31.2085C37.4062 30.9184 37.5215 30.6402 37.7266 30.4351C37.9317 30.23 38.2099 30.1147 38.5 30.1147C38.7901 30.1147 39.0683 30.23 39.2734 30.4351C39.4785 30.6402 39.5938 30.9184 39.5938 31.2085V31.9377C39.59 32.2266 39.4735 32.5026 39.2692 32.7069C39.0649 32.9112 38.7889 33.0276 38.5 33.0314Z",
    fill: "#FF6E4A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1157_2452",
    x: 0.5,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1157_2452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1157_2452",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d921e09c3a7e5a9a96fbc1ee418fe821.svg";
export { ForwardRef as ReactComponent };